var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlashdot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Slashdot",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "#006c66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.778 452.813L270.453 56h76.484L170.316 452.813zm324.444-60.018c0-34.884-28.418-63.204-63.44-63.204-35.053 0-63.44 28.32-63.44 63.204 0 34.924 28.387 63.204 63.44 63.204 35.022 0 63.44-28.28 63.44-63.204z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashdot);
export default __webpack_public_path__ + "static/media/slashdot.0aaa7aa664b39ee0945ab192b6f12fe2.svg";
export { ForwardRef as ReactComponent };